import { render, staticRenderFns } from "./MrpaBaseAuthority.vue?vue&type=template&id=47cdb2e5&"
import script from "./MrpaBaseAuthority.vue?vue&type=script&lang=js&"
export * from "./MrpaBaseAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports